// When the document is loaded, do these tasks
jQuery(document).ready(function () {

    // Add accordion class toggle
    jQuery('.panel-label').on('click', function() {
        var content = jQuery(this).next('.panel-content'),
            height = content[0].scrollHeight;

        if (jQuery(this).hasClass('open')) {
            content.css('height', 0);
        } else {
            content.css('height', height);
        };
        jQuery(this).toggleClass('open');
    });

    jQuery('.search-toggle').on('click', function() {
        jQuery('.search-area.desktop').toggleClass('open');
        jQuery(this).toggleClass('open');
    } ) ;

    jQuery('.nav-toggle').on('click', function() {
        jQuery(this).toggleClass('open');
    } ) ;

});
